import React from "react";
import ModalTreeInput from "../../../core/ModalTreeInput";
import { labels } from "../../../../localization/labels";

const ClassificationSelection = ({
  data,
  loadedKeys,
  loadData,
  onItemClick,
  pageInfo,
  onPageNumberClick,
  onSearchChange,
  classifications,
  removeData,
  treeRef,
  searchValue,
  readOnly,
  classificationsFilter
}) => {
  return (
    <ModalTreeInput
      treeRef={treeRef}
      removeItem={removeData}
      listTitle={labels.selectedClassifications}
      selectedData={classifications}
      treeTitle={labels.chooseClassification}
      data={data}
      loadedKeys={loadedKeys}
      loadData={loadData}
      onClick={onItemClick}
      pageInfo={pageInfo}
      onPageNumberClick={onPageNumberClick}
      onSearchChange={onSearchChange}
      searchable={true}
      searchValue={searchValue}
      readOnly={readOnly}
      classificationsFilter={classificationsFilter}
    />
  );
};

export default ClassificationSelection;
